import * as XLSX from 'xlsx';

// default Root for URLs
export const rootUrl = (to) => {
    // return "http://financial.gramosic.com/financialBackend" + to;
    // return "http://localhost:8888/financialBackend" + to;
    return "/financialBackend" + to;
}

// check if email is valid
export const checkEmailValidation = (email) => {
    // Regular expresion for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

export function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
        monthDifference < 0 || 
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }
    return age;
}

export function humanizeString(string) {
    // Replace underscores and hyphens with spaces
    let humanized = string.replace(/[_-]/g, ' ');

    // Convert camelCase to separate words with spaces
    humanized = humanized.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Capitalize the first letter of each word
    humanized = humanized.replace(/\b\w/g, c => c.toUpperCase());

    return humanized;
}

/**
 * Creates a new object containing only the specified keys from the original object.
 * @param {Object} object - The original object.
 * @param {Array} keys - An array of keys to pick from the original object.
 * @returns {Object} - A new object containing only the selected keys from the original object.
 */
export function selectObjectProperties(object, keys) {
    return Object.fromEntries(
        Object.entries(object)
            .filter(([key]) => keys.includes(key))
    );
}

export function formatDate(dateString) {
    const dateObj = new Date(dateString.trim())

    if (dateObj) {
        return dateObj.toDateString()
    }
    return "Invalid date format"
}

// export function formatToZMW (amount) {
//     return new Intl.NumberFormat('en-ZM', { 
//         style: 'currency', 
//         currency: 'ZMW' 
//     }).format(amount);
// };

export function formatToZMW(amount) {
  return new Intl.NumberFormat('en-ZM', { 
      style: 'decimal', 
      minimumFractionDigits: 2,  // Ensures two decimal places
      maximumFractionDigits: 2   // Limits the number of decimals to 2
  }).format(amount);
}


export function numberToWords(amount) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
  ];
  const teens = [
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "Ten", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
  ];
  const thousands = [
    "", "Thousand", "Million", "Billion", "Trillion"
  ];

  // Helper function to convert numbers less than 1000 to words
  function convertToWords(num) {
    let word = "";

    if (num > 99) {
      word += `${units[Math.floor(num / 100)]} Hundred `;
      num %= 100;
    }

    if (num > 10 && num < 20) {
      word += `${teens[num - 11]} `;
    } else {
      word += `${tens[Math.floor(num / 10)]} `;
      word += `${units[num % 10]} `;
    }

    return word.trim();
  }

  if (isNaN(amount) || amount === 0) {
    return "Zero";
  }

  let integerPart = Math.floor(amount);
  let decimalPart = Math.round((amount - integerPart) * 100);

  let words = "";
  let i = 0;

  while (integerPart > 0) {
    const chunk = integerPart % 1000;
    if (chunk > 0) {
      words = `${convertToWords(chunk)} ${thousands[i]} ${words}`.trim();
    }
    integerPart = Math.floor(integerPart / 1000);
    i++;
  }

  // Add decimal part (if any)
  if (decimalPart > 0) {
    words += ` and ${convertToWords(decimalPart)} Ngwee`;
  }

  return words.trim();
}

export const handlePrint = (componentRef) => {
  const printContent = componentRef.current;
  const printWindow = window.open("", "", "width=800,height=600");
  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Page</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @media print {
            body { margin: 20px; }
          }
        </style>
      </head>
      <body class="p-4">${printContent.innerHTML}</body>
    </html>
  `);
  printWindow.document.close();

  // Ensure Tailwind is applied before printing
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


export const handleExcel = (componentRef, name) => {
      const input = componentRef.current;
      if (!input) return;
      // Extract table or structured data from the ref
      const rows = Array.from(input.querySelectorAll('tr')).map((row) => {
        return Array.from(row.querySelectorAll('th, td')).map((cell) => cell.textContent);
      });
    
      // Create a worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
    
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
      // Export the workbook as an Excel file
      XLSX.writeFile(workbook, `${name}.xlsx`);
    }



export const getAllConstituencies = (provinces) => {
  const constituencies = [];
  Object.values(provinces).forEach((province) => {
    Object.values(province.districts).forEach((district) => {
      constituencies.push(...district);
    });
  });
  return constituencies;
};
  
